import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        target: false,
        htmlContent: '',
        reviewerWay: null
    },
    mutations: {
        // 处理审方方式改变
        hanldeReviewerWayChange(state, payload) {
            state.reviewerWay = payload
        },

    },
    actions: {

    },
    getters: {

    },
    modules: {
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js